//Me permite obviamente crear una guia de remision, pedido por mi tia Gladis
//alert(JSON.stringify(registrosFullState,null,2) )
//Junio 2026
import React, {useState,useEffect} from 'react'
import {Modal,ModalHeader,ModalBody,ModalFooter,Form,FormGroup,Button,ButtonGroup,Input,Label, InputGroup, CardGroup, ListGroup, ListGroupItemHeading} from 'reactstrap'
import {Dropdown,DropdownItem, DropdownMenu,DropdownToggle} from 'reactstrap'
//Para las pestanas TAB y otros
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col} from 'reactstrap'
import DataTable from 'react-data-table-component'
import buscarPhpPath, { aceptarSoloEnteros,aceptarDecimales,verificarSiTextoEsPurosDigitos,generarPresupuestoPDFconSwal,generarNotaEntregaPDFconSwal,generarFacturaDeVentaSimple_ConSwal,determinarFormatoImpresoraGrande,hayInternet,ejecutarFetchGenericoConSwal  } from './lib_basica'
import {gestionarCatch,mostrarSwalEspera,apagarSwal,mostrarSwalBotonAceptar,mostrarSwalBotonAceptarBucle,mostrarSwalPos,mostrarSwalUnSegundo,mostrarSwalConfirmacionEliminarAnular,mostrarSwalReintentar,devolverFechaHoyTextoYYYYMMDD,textoDelCombo,formatearFechaHoraDevuelveDDMMYY,sleepPepe } from './lib_basica'
//del context
import {AppContextConsumer} from './ContextBase'
//awensome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faDownload,faBan,faWindowClose,faClipboard ,faFlag,faParking,faFileAlt,faDoorClosed,faDoorOpen, faBroom,faBarcode, faArrowDown,faArrowCircleDown,faArrowAltCircleDown,faEye,faPager,faCaretDown,faChevronCircleDown,faFileInvoiceDollar,faListOl,faPercent,faLayerGroup, faCubes,faSearch,faMinus,faPlusCircle,faPlus,faCheckCircle,faCheck,faTimes,faTimesCircle,faBookReader,faUserAlt,faUser,faUserPlus,faUserAltSlash,faEnvelope,faCommentDollar, faDollarSign, faMoneyBill, faMoneyBillAlt, faCashRegister,  faAddressCard, faPrint, faFileExcel,faEdit,faReplyAll,faTrashAlt,faEllipsisH,faEllipsisV,faSyncAlt, faArrowAltCircleLeft, faGrinTongueSquint } from '@fortawesome/free-solid-svg-icons' 
//Modales, Formularios
import PedirTextoGenericoSerie from './PedirTextoGenerico' //Para pedir/cambiar la serie (le puse 100 caractares maximo)
import PedirCantidad from './PedirCantidad'
import PedirTextoComplementario from './PedirTextoComplementario' //Para pedir texto complementario de la Factura (maximo 300)
//************** React-DatePicker ******/
import DatePicker, { registerLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import es from 'date-fns/locale/es' //'es' sirve para que los nombres de los meses salgan en espanol
import { width } from '@fortawesome/free-solid-svg-icons/fa0'
import TabelaClientesBuscadorEnBDD from './TabelaClientesBuscadorEnBDD'
//import { type } from '@testing-library/user-event/dist/cjs/utility/type.js'
registerLocale('es',es) 

let valueDC=null //Esta variable me sirve para tener una copia de los valores del context  
let facturaBuscada=null //Aqui guardo el registro [0] de la consulta v_facturacondetalleimprimir, mas que todo para poder mostrar el encabezado de la factura, y otros datos útiles
let def_IdRojoDestinatario=null //guardo el rojo de destinatario definitivo, ya que podría cambiar
let def_CiRucDestinatario=null //guardo la ci/ruc del destinatario definitivo, ya que podría cambiar
let def_NombreDestinatario=null //guardo el nombre del destinatario definitivo, ya que podría cambiar
let def_TextoComplementario=null //al principio me copio el mismo texto complementario de la factura
let rowRegistroClon=null //es una copia de la fila del grid. (ya que no siempre el estado se actualiza tan rapido, la variable si es rapida)
let codigoRojoDevueltoPorSql=null //cuando es nuevo el sql me devuelve un autonumerico. [Cuando es editar, me devuelve el mismo rojo enviado]

const miEstilacho={
	table: {
		style: {
			minHeight: '25vh',      
		},
	},    
  //el header, se refiere al titulo que dice 'ITEMS SELECCIONADOS'
  header: {
    style: {
      color: 'black',
      backgroundColor: 'hotpink',
      //fontSize:'22px',   
      //fontWeight: 'bold',
    },
  },  
  headCells: {
    style: {
      background: 'pink', //ok hotpink
      color: 'gray',  //ok lavender
      fontSize:'16px',   //ok
      fontWeight: 'bold'
    },
  },
  rows: {    
    style: {
      minHeight: '40px', // bacan '30px' o 20% (le puse 44px para que el boton de EDITAR quede centrado a lo alto)
      //color:'yellow', //ok funciona bien
      //background:'blue', //bacan
      //marginTop:'4px',
      //marginBottom:'10px',
    }
  },  
  cells: {
    style: {
      fontSize:'16px',
      cursor: 'pointer',
      //el borde solo lo quiero ABAJO
      // top | right | bottom | left 
      //border-style: none solid dotted dashed;      
      borderStyle:"none none solid none", 
      borderColor:'silver',
      borderWidth:'thin',                 
      //color: 'dimgray', // NO USAR EL COLOR AQUI. el color de la celda se maneja en  FILACONDICIONAL      
    },
  },
}

const filaCondicionalExterna=(filaClonada)=>[
  //fila NO seleccionada
  {
    when: row => (row.FilaD != filaClonada?.FilaD),
    style: row => ({ 
      backgroundColor: 'white',
      color: 'dimgray', 
     }),    
  },
  //fila seleccionada    
  { 
    //al tocar una fila se debe poner azul. Pero si la fila esta anulada se debe mantener el tachado
    when: row => (row.FilaD == filaClonada?.FilaD ),
    style: row=> ({    
      backgroundColor: valueDC.sistema.coloresFilaSeleccionadaPrincipal,
      color: 'white', 
    }),
  },
]

const IncGuiaRemision=(props)=>{
  const [nombreComponenteParaVerState,set_nombreComponenteParaVerState]=useState('guia')
  const [lecturaBDDsuperado,set_lecturaBDDsuperado]=useState(true) //Al arrancar el FORM, asumo que todo saldrá bien (al arrancar el FORM hay que leer en la BDD. ALomejor podría regrasar con null)
  const [registrosFullState,set_registrosFullState]=useState([]) //para guardar todos los registros Osea al inicio es lo que está ligado a la tabela
  const [rowRegistroState,set_rowRegistroState]=useState(null) //mas que todo para color de la fila seleccionada y la tabela     
  //parte transportista
  const [comboIdentidad,set_comboIdentidad]=useState("")  //[04,05,] 04=>Ruc, 05=>Cedula
  const [txtCiRucTransportista,set_txtCiRucTransportista]=useState()  
  const [txtTransportistaNombre,set_txtTransportistaNombre]=useState()  
  const [txtPlaca,set_txtPlaca]=useState()  
  const [txtCorreo,set_txtCorreo]=useState()  
  //parte destinatario (de la tala clientes)
  const [txtCiRucDestinatario,set_txtCiRucDestinatario]=useState()  
  const [txtDestinatarioNombre,set_txtDestinatarioNombre]=useState()    
  //parte viaje
  const [txtFechaInicio,set_txtFechaInicio]=useState("")  //en modo latino dd/mm/yyyy
  const [txtPuntoPartida,set_txtPuntoPartida]=useState() 
  const [txtRuta,set_txtRuta]=useState() 
  const [txtFechaFin,set_txtFechaFin]=useState("")  //en modo latino dd/mm/yyyy
  const [txtPuntoLlegada,set_txtPuntoLlegada]=useState() 
  const [txtMotivo,set_txtMotivo]=useState("VENTA DE MERCADERIA") 
  const [txtObservaciones,set_txtObservaciones]=useState("") 
  //Modales
  const [modalPedirCantidad,set_modalPedirCantidad]=useState(false)
  const [modalPedirDescripcion,set_modalPedirDescripcion]=useState(false) //para cambiar la descripcion
  const [modalSerial,set_modalSerial] =useState(false)  
  const [modalTextoComplementario,set_modalTextoComplementario] =useState(false)  
  const [modalClientesBuscadorEnBDD,set_modalClientesBuscadorEnBDD] =useState(false)  

//Estructura para el DataTable
const miEstructuraDataTable=[  
  {  
    name:'FILA',
    selector:row => row.FilaD, //Aqui debe ir un valor/orden/fila/Autonumerico que sirva de clave para el dataTable
    center:true,
    //grow:0.2,
    omit:true, //debe estar oculta.
  },
  {  
    name:'IDR',
    selector:row => row.CodProductoRojoD,
    center:true,
    //grow:0.2,
    omit:true, //debe estar oculta.
  },   
  {
    name:'PRINCIPAL',
    selector:row => row.CodPrincipal,
    sortable:false,
    left:true,
    compact:true,
    grow:0.5, //es una medida relativa (1 es mi referencia)
  },  
 {
    name:'SECUNDARIO',
    selector:row => row.CodSecundario,
    sortable:false,
    left:true,
    compact:true,
    grow:0.5, //es una medida relativa (1 es mi referencia)
    omit:true, //debe estar oculta.
  },  
  {
    name:'DESCRIPCION',
    selector:row => row.DescripcionRealD, 
    sortable:false,
    left:true,
    compact:true,
    grow:2.5,
    //width:'50%', //probando
  },         
  {  
    name:'CANT.COMPRADA',
    selector:row => row.CantD,  //cant comprada
    sortable:false,
    center:true,
    grow:1,
    compact:true, //padding 0
    omit:true, //debe estar oculta.
  },      
  {  
    name:'CANT', //cantidad a transportar
    selector:row => row.CantGuia,  // 
    sortable:false,
    center:true,
    grow:0.5,
    compact:true, //padding 0
  },      
  //=========================
  //======= ACCIONES 
  //=========================
  {
    name:'',
    sortable:false,
    center:true,
    compact:true,
    grow:1,  
  
    //esto funciona fino
    //cell: (row) => <div><div style={{ fontWeight: 'bold' }}>{row.factura17}</div>{row.IdPrincipal}</div>,
    //esto funciona fino
    //cell: (row) => <div style={{ fontWeight: 900 }}>{row.factura17}</div>,
    //<div style={{ display:'flex' }}>            
    cell: (row) => 
    <div style={{ display:'flex' }}>            
        {/* hay un error al poner primary. se debe poner primary ="true" (revisar en la documentacion de ReactsTrap */}
        {/* tambien da error al poner raised. se debe poner raised="true"  */}
        {/* o se puede poner raised= {miVariable.toString() }  */}
  
      <Button id="btnCantidad" name="btnCantidad" style={{ marginRight:'1px' }} raised = "true" primary='false' color="info" 
       onClick={ (e) => {
        set_rowRegistroState(row)
        rowRegistroClon=row
        set_modalPedirCantidad(true)
        }}>
        <FontAwesomeIcon size='lg' color="white" icon={faLayerGroup}/>
      </Button>
  
      <Button id="btnDescripcion" name="btnDescripcion" style={{ marginRight:'1px' }} raised = "true" primary='false' color="info" 
       onClick={(e)=>{      
        set_rowRegistroState(row)
        rowRegistroClon=row
        set_modalPedirDescripcion(true)
        }}>
        <FontAwesomeIcon size='lg' color="white" icon={faEdit} />
      </Button>          

      <Button id="btnSerial" name="btnSerial" style={{ marginRight:'1px' }} raised = "true" primary='false' color="info" 
       onClick={(e)=>{      
        set_rowRegistroState(row)
        rowRegistroClon=row
        set_modalSerial(true)
        }}>
        <FontAwesomeIcon size='lg' color="white" icon={faBarcode} />
      </Button>          
     
    </div>,
    },
    //======= fin de acciones
  {
    name:'SERIE',
    selector:row => row.DescripcionAmpliadaD, //Para la serie (pero nunca se usan los 300 caractedes de la BDD, quiza 100)
    sortable:false,
    left:true,
    compact:true,
    grow:1,
  }, 
];

const gestionar_GR_6pasos=()=>{
  //busco el formato del usuario logeado(this.valueDC.estable.Estab), generalmente: A4v
  let miFormato=determinarFormatoImpresoraGrande(valueDC,valueDC.estable.Estab,'FormatoGuiaSri')
  if (miFormato==''){
    console.log("No se consigue el formato, desde el modulo de guias para formato de guia sri")          
    return
  }  
  //llamo a una funcion en PHP que hace los 6 pasos. Pero NUNCA espero la respuesta
  let miPhpFile=  buscarPhpPath() + 'Contr_Generico.php'
  let data=new FormData()
  data.append('miSol','gestionar_DocumentoSri_6pasos')
  data.append('prefijoDoc',"GR") 
  data.append('miFormato',miFormato)  //generalmente A4v
  data.append('miEstab',valueDC.usuario.EstabUsu) 
  data.append('miPunto',valueDC.usuario.PuntoUsu) 
  data.append('numDoc',codigoRojoDevueltoPorSql) //numero de guia que se acaba de generar 
  data.append('miContext', JSON.stringify(valueDC) ) //le mando el context completo
  data.append('destinoNombre',document.getElementById("txtTransportistaNombre").value.trim()) //para el correo, se usa el nombre del transportista
  data.append('destinoEmail',document.getElementById("txtTransportistaCorreo").value.trim())  
  data.append('resolverSN', "N") // no se desea resolver, ya que eso se usa en la tabela, para documentos ROJOS
  fetch(miPhpFile, { method: 'POST',body:data }) //No espero la respuesta 
}   

const ParteDestinatario=()=> {   
//ya van a aparecer los datos del destinatario pre-escritos con la misma direccion del cliente. PERO OBVIAMENTE SE PUEDEN EDITAR
return (
<div id="divParteDestinatario" name="divParteDestinatario" style={{background:'white', marginLeft:'2%', marginRight:'2%',marginTop:'0%',padding:'10px',borderStyle:'solid',borderWidth:'1px',borderColor:'gray'}}>         
  <Row style={{margin:'0'}}>
    <Col xs="12" style={{padding:'0',display:"flex"}}>
     <label style={{width:'9%'}}>Ci/Ruc</label>
     <Input style={{paddingLeft:'1%',paddingRight:'0',paddingTop:'0',paddingBottom:'0',width:'19%' }} name="txtCiRucDestinatario" id="txtCiRucDestinatario" value={txtCiRucDestinatario} disabled/>      
     <label style={{marginLeft:"1%",marginRight:"1%"}}>Nombre</label>
     <Input style={{paddingLeft:'1%',paddingRight:'0',paddingTop:'0',paddingBottom:'0' }} name="txtDestinatarioNombre" id="txtDestinatarioNombre" value={txtDestinatarioNombre} disabled/>
     <Button id="btnBuscarCliente" name="btnBuscarCliente" color="secondary" solid="true" style={{width:"15%",color:'white',marginLeft:'1%'}}
       onClick={async()=>{
        set_modalClientesBuscadorEnBDD(true)
       }}>Cambiar...
     </Button>      
    </Col> 
  </Row>
</div>
)}    

const ParteTransportista=()=> {   
//Datos personales del transportista
return (
<div id="divParteTransportista" name="divParteTransportista" style={{background:'white', marginLeft:'2%', marginRight:'2%',marginTop:'0%',padding:'10px',borderStyle:'solid',borderWidth:'1px',borderColor:'gray'}}>         
  <Row style={{margin:'0'}}>
    <Col xs="12" style={{padding:'0',display:"flex"}}>
      <label for="txtCiRucTransportista" style={{width:'8%'}}>Ci/Ruc</label>
      <Input style={{paddingLeft:'1%',paddingRight:'0',paddingTop:'0',paddingBottom:'0',width:'19%' }} name="txtCiRucTransportista" id="txtCiRucTransportista" value={txtCiRucTransportista} maxLength="13"
        onKeyPress={(e)=>aceptarSoloEnteros(e)}
        onChange={(e)=>set_txtCiRucTransportista(e.target.value)}
      />      
      <label for="txtTransportistaNombre" style={{marginLeft:"1%",marginRight:"1%",width:"20%"}}>Nombre transportista</label>
      <Input style={{paddingLeft:'1%',paddingRight:'0',paddingTop:'0',paddingBottom:'0' }} name="txtTransportistaNombre" id="txtTransportistaNombre" value={txtTransportistaNombre} maxLength="100"
        onChange={(e)=>set_txtTransportistaNombre(e.target.value)}
      />      
    </Col> 
    <Col xs="12" style={{padding:'0',marginTop:"1%",display:"flex"}}>
      <label for="txtPlaca" style={{width:'7%',}}>Placa</label>
      <Input style={{paddingLeft:'1%',paddingRight:'0',paddingTop:'0',paddingBottom:'0',width:"15%" }} name="txtPlaca" id="txtPlaca" value={txtPlaca} maxLength="12" 
        onChange={(e)=>set_txtPlaca(e.target.value)}
      />
      <label for="txtTransportistaCorreo" style={{marginLeft:"1%",width:"8%"}}>Correo</label>
      <Input style={{paddingLeft:'1%',paddingRight:'0',paddingTop:'0',paddingBottom:'0',width:"40%" }} name="txtTransportistaCorreo" id="txtTransportistaCorreo" value={txtCorreo} maxLength="60" 
        onChange={(e)=>set_txtCorreo(e.target.value)}
      />
    </Col> 
  </Row>
</div>
)}    

const ParteViaje=()=> {   
//Parte para poner los datos del viaje (fechas,origen,destino,ruta.....)
return (
<div id="divParteViaje" name="divParteViaje" style={{background:'white', marginLeft:'2%', marginRight:'2%',marginTop:'0%',padding:'10px',borderStyle:'solid',borderWidth:'1px',borderColor:'gray'}}>
  <Row style={{margin:'0'}}>
    <Col xs="12" style={{padding:'0',display:"flex"}}>
      <Label for="txtFechaInicio" style={{width:"8%",marginRight:'1%'}}>Fecha Inicio</Label>
      <DatePicker autoComplete='off' className="anchoDatePickerGenerico" id="txtFechaInicio" name="txtFechaInicio"
        locale='es' dateFormat="dd/MM/yyyy"
        selected={ txtFechaInicio }          
        onChange= {(datePar)=>set_txtFechaInicio(datePar) }
      />  
      <Label for="txtPuntoPartida" style={{width:"10%",marginLeft:"1%", marginRight:'1%'}}>Punto de partida</Label>        
      <Input style={{width:"30%",paddingLeft:'1%',paddingRight:'0',paddingTop:'0',paddingBottom:'0' }} name="txtPuntoPartida" id="txtPuntoPartida" value={txtPuntoPartida} maxLength="300"
        onChange={(e)=>set_txtPuntoPartida(e.target.value)}
      />      
      <Label for="txtRuta" style={{width:"5%",marginLeft:"2%",marginRight:'1%'}}>Ruta</Label>
      <Input style={{width:"33%",paddingLeft:'1%',paddingRight:'0',paddingTop:'0',paddingBottom:'0' }} name="txtRuta" id="txtRuta" maxLength="100" value={txtRuta }
        onChange={(e)=>set_txtRuta(e.target.value)}
      />       
    </Col>
  </Row>
  <Row style={{margin:'0',marginTop:'1%'}}>
    <Col xs="12" style={{padding:'0',display:"flex"}}>            
      <Label for="txtFechaFin" style={{width:"8%",marginRight:'1%'}}>Fecha Fin</Label>
      <DatePicker autoComplete='off' className="anchoDatePickerGenerico" id="txtFechaFin" name="txtFechaFin" 
        locale='es' dateFormat="dd/MM/yyyy"
        selected={ txtFechaFin }          
        onChange= {(datePar)=>set_txtFechaFin(datePar) }
      />  
      <Label for="txtPuntoLlegada" style={{width:"10%", marginLeft:"1%",marginRight:'1%'}}>Punto de llegada</Label>        
      <Input style={{width:"70%",paddingLeft:'2%',paddingRight:'0',paddingTop:'0',paddingBottom:'0' }} name="txtPuntoLlegada" id="txtPuntoLlegada" maxLength="300" value={txtPuntoLlegada}
        onChange={(e)=>set_txtPuntoLlegada(e.target.value)}
      />
    </Col> 
  </Row>
  <Row style={{margin:'0',marginTop:"1%"}}>
    <Col xs="12" style={{padding:'0',display:"flex"}}>
      <Label for="txtMotivo" style={{marginRight:'3%'}}>Motivo</Label>        
      <Input style={{paddingLeft:'1%',paddingRight:'0',paddingTop:'0',paddingBottom:'0' }} name="txtMotivo" id="txtMotivo" maxLength="100" value={txtMotivo}
        onChange={(e)=>set_txtMotivo(e.target.value)}
      />
    </Col> 
  </Row>
</div>
)}    

const PartePie=()=> {   
//para el boton de texto Complementario y el campo de observaciones
return (
<div id="divPartePie" name="divPartePie" style={{background:'white', marginLeft:'2%', marginRight:'2%',marginTop:'1%', marginBottom:'1%',padding:'10px',borderStyle:'solid',borderWidth:'1px',borderColor:'gray'}}>         
  <Row style={{margin:'0'}}>
    <Col xs="12" style={{padding:'0',display:"flex"}}>
      <Button id="btnTextoC" name="btnTextoC" color="secondary" solid="true" style={{width:"15%",color:'white',margin:'0%'}}
        onClick={async()=>{
          set_modalTextoComplementario(true)
        }}>Texto Complementario
      </Button>      
      <Input style={{paddingLeft:'1%',paddingRight:'0',paddingTop:'0',paddingBottom:'0',marginLeft:'2%' }} name="txtObservaciones" id="txtObservaciones" placeholder="Observaciones" value={txtObservaciones} maxLength="100"
        onChange={(e)=>set_txtObservaciones(e.target.value)}
      />      
    </Col> 
  </Row>
  <Row style={{margin:'0',marginTop:"1%"}}>
    <Col xs="12" style={{padding:'0',textAlign:"center"}}>
      <Button id="btnGuardarGuia" name="btnGuardarGuia" color="success" solid="true" style={{width:"100%",color:'white',marginBottom:'0%',}}
        onClick={async()=>{
          await guardarGuiaRemision() 
          if (codigoRojoDevueltoPorSql==null) return //quiere decir que NO se pudo guardar el registro
          // al recibir negativo, es que hubo algun error 
          if (codigoRojoDevueltoPorSql<0){
           await mostrarSwalBotonAceptar("warning","NO SE PUDO GUARDAR","Revise sus datos e intente de nuevo")
           return 
          }
          //todo cool
          gestionar_GR_6pasos() //lo mando en segundo plano, NO espero la respuesta 
          await mostrarSwalBotonAceptar("success","GUIA CREADA","CORRECTAMENTE")
          props.cerrarGuia('save')  //Correcto
        }}>GUARDAR y FINALIZAR
      </Button>      
    </Col> 
  </Row>

</div>
)}    

const actualizarGridConDatosNuevos=(campo,valor)=>{
//la idea es modificar el grid.
//Me sirve para actualizar [Cantidad a transportar],[Descripcion], [Serial] cualquiera de esas 3

//me sirve para hacer una simulacion del clic en la misma linea azul (pero ya con los nuevos datos)
let filaModificadaClic=null 

//Paso a un nuevo array, todo el contenido del grid 
let datosFullCopiaMod=registrosFullState.map(item=>{
  if (item.FilaD==rowRegistroClon.FilaD){
    if (campo=="CantGuia"){
      item.CantGuia=valor
    }    
    if (campo=="DescripcionRealD"){
      //Se refiere a la descripcion 
      item.DescripcionRealD=valor
    }
    if (campo=="DescripcionAmpliadaD"){
      //Se refiere al seria
      item.DescripcionAmpliadaD=valor
    }    
  filaModificadaClic=item  //para simular el clic en la misma fila azul
  }
  return item
})

set_registrosFullState(datosFullCopiaMod)    
//debo simular un clic sobre el registro afectado.
set_rowRegistroState(filaModificadaClic)  
rowRegistroClon=filaModificadaClic
}

const validarGuia=()=>{  
//------------------------------------------
//------ TRANSPORTISTA  --------------------
//------------------------------------------
let txtLoco=null //me va a servir para cualquier validacion
let numLoco=null //numero loco para cualquier validacion

txtLoco= document.getElementById("txtCiRucTransportista").value.trim()
if (txtLoco.length==0 ){
  mostrarSwalBotonAceptar("error","ATENCION","Debe indicar la Cédula/Ruc del Transportista")
  return false  
}  
//Se debe validar que sea 10 digitos o 13. y que termine en 001
numLoco=(document.getElementById("txtCiRucTransportista").value).trim().length
txtLoco= document.getElementById("txtCiRucTransportista").value.trim()
if (numLoco != 10 && numLoco != 13){
  mostrarSwalBotonAceptar("error","ATENCION","La cédula/ruc debe tener 10 o 13 digitos")
  return false  
}    
//Al ser 13 digitos reviso que debe terminar en 001
if (numLoco == 13){
  txtLoco=(txtLoco.substring(10,13)).trim()
  if (txtLoco != "001"){
  mostrarSwalBotonAceptar("error","ATENCION","El ruc del transportista debe terminar en 001")
  return false  
}    
}
txtLoco= document.getElementById("txtTransportistaNombre").value.trim()
if (txtLoco.length==0 ){
  mostrarSwalBotonAceptar("error","ATENCION","Debe indicar el nombre del Transportista")
  return false  
}    
txtLoco= document.getElementById("txtPlaca").value.trim()
if (txtLoco.length==0 ){
  mostrarSwalBotonAceptar("error","ATENCION","Debe indicar la placa")
  return false  
}      
txtLoco= document.getElementById("txtTransportistaCorreo").value.trim()
if (txtLoco.length==0 ){
  mostrarSwalBotonAceptar("error","ATENCION","Debe indicar el correo del transportista")
  return false  
}      
//------------------------------------------
//------ VIAJE  --------------------
//------------------------------------------
txtLoco= document.getElementById("txtPuntoPartida").value.trim()
if (txtLoco.length==0 ){
  mostrarSwalBotonAceptar("error","ATENCION","Debe indicar el punto de partida")
  return false  
}  
txtLoco= document.getElementById("txtRuta").value.trim()
if (txtLoco.length==0 ){
  mostrarSwalBotonAceptar("error","ATENCION","Debe indicar la ruta")
  return false  
}  
txtLoco= document.getElementById("txtPuntoLlegada").value.trim()
if (txtLoco.length==0 ){
  mostrarSwalBotonAceptar("error","ATENCION","Debe indicar el punto de llegada")
  return false  
}  
txtLoco= document.getElementById("txtMotivo").value.trim()
if (txtLoco.length==0 ){
  mostrarSwalBotonAceptar("error","ATENCION","Debe indicar el motivo")
  return false  
} 
//------------------------------------------
//------ FECHAS DEL VIAJE  -----------------
//------------------------------------------
let fechaInicioMilisegundos=txtFechaInicio.getTime()
let fechaFinMilisegundos=txtFechaFin.getTime()
if (fechaFinMilisegundos<fechaInicioMilisegundos ){
  mostrarSwalBotonAceptar("error","ATENCION","La fecha de inicio debe ser menor que la fecha de fin")
  return false  
}  

//------------------------------------------
//------ GRID DEL DETALLE  -----------------
//------------------------------------------
//La idea es revisar que realmente existan productos en el grid (osea que la cantidad global > 0)
//Voy a hacer una sumatoria de las cantidades
 
let cantGlobalGuia=0 
for (const item of registrosFullState) {
  let cantEnFila=parseFloat(item.CantGuia)  
  cantGlobalGuia +=cantEnFila
}
if (cantGlobalGuia==0 ){
  mostrarSwalBotonAceptar("error","ATENCION","La cantidad a transportar debe ser mayor que CERO")
  return false  
}  
return true
}
  
const mostrarDatos=()=>{
//Al inicio, el destinatario es el mismo cliente

//destinatario
def_IdRojoDestinatario=facturaBuscada.IDr_Cliente
def_CiRucDestinatario=facturaBuscada.IdPrincipal
def_NombreDestinatario=facturaBuscada.RazonSocial
set_txtCiRucDestinatario(def_CiRucDestinatario)
set_txtDestinatarioNombre(def_NombreDestinatario)

//viaje 
//set_txtPuntoPartida(facturaBuscada.Direccion)
//Fecha de inicio (desde SQL viene yyyy-mm-dd +la hora)
let miAno=facturaBuscada.FechaEmision.substring(0,4)
let miMes=facturaBuscada.FechaEmision.substring(5,7)
let miDia=facturaBuscada.FechaEmision.substring(8,10)
//OJO: Al usar el metodo DATE con 3 string, el mes de enero es 0. OJO
//a la fecha de inicio y fin le pongo la misma
set_txtFechaInicio(new Date(miAno,miMes-1,miDia))
set_txtFechaFin(new Date(miAno,miMes-1,miDia))
//Observaciones
set_txtObservaciones(facturaBuscada.ObservacionesFactura)
//Texto complementario (hago una copia ya que se debe llamar a un modal para cambiar)
def_TextoComplementario=(facturaBuscada.TextoComplementario==null ? "" : facturaBuscada.TextoComplementario)  
}

const buscarFactura=async()=>{
  let data=new FormData()
  data.append('miSol','guia_buscarContenidoFactura')
  data.append('miEstab',props.rowRegistroClon.Estab)
  data.append('miPunto',props.rowRegistroClon.Punto)   
  data.append('miNumFac',props.rowRegistroClon.NumFac)
  
  let dataApi=await ejecutarFetchGenericoConSwal(valueDC.sistema.numeroDeReintentosPhp,valueDC.sistema.milisegundosParaNuevoReintentoPhp,data)
  if (dataApi==null) set_lecturaBDDsuperado(false)
  if (dataApi==null) return   

  set_registrosFullState(dataApi)     //la variable registrosFullState lo uso en el grid, para ver el contenido de la factura
  facturaBuscada=dataApi[0] //cuando es Incluir viene null. Cuando es Modificar o Consultar si viene null es porque el cliente buscado ya no existe (alomejor lo borraron desde otra pc)

  mostrarDatos()  
}

//************ simulo el componentDidMount */
//el useEffect me simula el didMount (siempre y cuando los corchetes [] esten vacios) 
useEffect(()=>{  
  //caso 1: cuando se desea NUEVO registro
  if (props.opcionRegistro_imc=='i'){
    document.getElementById("tituloGastoH1").innerText= 'NUEVA GUIA'  
  }

  //Leo de la base de datos
  buscarFactura()  //Lee de la bdd. 

  //al descargar, limpio algunas variables sensibles
  return () => {
    rowRegistroClon=null
    set_registrosFullState([])
    set_rowRegistroState(null)
  }      
  },[]
)
// *** cuando recibo NULL de mi API, entonces me devuelvo al llamador
useEffect(()=>{  
    if (lecturaBDDsuperado==false){    
    props.cerrarGuia("close")
  }
  },[lecturaBDDsuperado]
)
 
const ParteGrid=()=>{
return(
<div id="divParteGrid" name="divParteGrid" style={{marginLeft:'2%',marginRight:'2%',marginTop:'0',marginBotto:'0',width:'96%', borderStyle:'solid',borderColor:'black',borderWidth:'1px'}}>
  <DataTable
  //************ DATA TABLA PROPERTIES (basic) ***********/
  //title='Items Seleccionados'
  columns={miEstructuraDataTable}
  data={registrosFullState}
  conditionalRowStyles={filaCondicionalExterna(rowRegistroClon)}  
  keyField ='FilaD' /* Se puede poner 'id' (valor por omision), 'IDr' o cualquier campo que sea mi clave...obligatoriamente se refiera a la propiedad SELECTOR */
  highlightOnHover  
  onRowClicked={(row) => { 
    set_rowRegistroState(row)
    rowRegistroClon=row
  }}
  //  noDataComponent = "<h1><span>Carrito Vacío</span></h1>"
  highlightOnHover

  //************ DATA TABLA PROPERTIES (row selection) ***********/
  //selectableRows //aparece el checkbox
  //selectableRowsVisibleOnly
  //selectableRowsHighlight
  //selectableRowsNoSelectAll

  //************ DATA TABLA PROPERTIES (row expander) ***********/
  //expandableRows //interesante

  //************ DATA TABLA PROPERTIES (sorting) ***********/
  //defaultSortField

  //************ DATA TABLA PROPERTIES (header) ***********/
  //actions //component or array of components

  //fixedHeader //Makes the tabale header fixed allowing you to scroll the table body
  
  //fixedHeaderScrollHeight = "400px" //valor por defecto 100vh 
  //subHeader //me gustaria esta opcion pero no funciona

  //************ DATA TABLA PROPERTIES (theme theming and customization) ***********/
  customStyles={miEstilacho} /* redefino algun estilo */
  
  />    { /* del componente DataTable */ }
  </div>
  )  
}

const prepararJSON_ConDatosDelGrid=()=>{
let vectorLoco=[]
for (const item of registrosFullState) {
  let cantValidar=parseFloat(item.CantGuia)  
  if (cantValidar>0){
    const x={
      FilaD: item.FilaD,
      CodProductoRojoD: item.CodProductoRojoD,
      CodPrincipalD: item.CodPrincipal,
      CodSecundarioD: item.CodSecundario,
      CantD: item.CantGuia,
      DescripcionD: item.DescripcionRealD,
      DescripcionAmpliadaD: (item.DescripcionAmpliadaD==null ? "" :  item.DescripcionAmpliadaD), //Serial (ojo que podría estar null, hay que cambiarlo a vacio)      
    }
    vectorLoco.push(x) //empujo el item
}
}
return vectorLoco
} 

const guardarGuiaRemision=async()=>{
  codigoRojoDevueltoPorSql=null
  if ( await validarGuia()==false) return  
     
  let data=new FormData(document.getElementById("miFormularioGuia"))
  data.append('miSol','guia_nueva')
  data.append('miContext',JSON.stringify(valueDC)) //le mando el context completo
  data.append('miEstablecimientoFA',props.rowRegistroClon.Estab) //estab de la factura original
  data.append('miPuntoEmisionFA',props.rowRegistroClon.Punto) //punto de la factura original
  data.append('miNumFA',props.rowRegistroClon.NumFac) //numero de factura, de la factura original
  data.append('miCodRojoDest',def_IdRojoDestinatario)  
  let largoTipoIdentificacionTrans=(document.getElementById("txtCiRucTransportista").value).trim().length //debe ser 10 u 13
  data.append('miTipoIdentificacionTrans',largoTipoIdentificacionTrans==10 ? "05" : "04" )   //05=>ruc. 04=>cedula
  //Le paso la fecha en modo string (es la unica forma que pude resolver este problema)
  let FechaInicioTexto=document.getElementById("txtFechaInicio").value
  FechaInicioTexto=FechaInicioTexto.trim() //dd-mm-yyyy (allá en PHP lo debo invertir)
  data.append('miFechaInicioTraslado',FechaInicioTexto)
  let FechaFinTexto=document.getElementById("txtFechaFin").value
  FechaFinTexto=FechaFinTexto.trim() //dd-mm-yyyy (allá en PHP lo debo invertir)
  data.append('miFechaFinTraslado',FechaFinTexto)  
  data.append('miTextoComplementario',def_TextoComplementario)  
  data.append('usuario',valueDC.usuario.LoginUsu) 
  let vectorDG=prepararJSON_ConDatosDelGrid()
  data.append('miJsonDG',JSON.stringify(vectorDG)) //Aqui se va el detalle de la Guia (el grid)

  let dataApi=await ejecutarFetchGenericoConSwal(valueDC.sistema.numeroDeReintentosPhp,valueDC.sistema.milisegundosParaNuevoReintentoPhp,data)
  if (dataApi==null) return
  
  //guardo el rojo devuelto por mi api (tambien me puede llegar negativo si hay error como por ejemplo cedula duplicada)
  codigoRojoDevueltoPorSql=dataApi
}

const ComponentePrincipalBody=()=>{
return(    
<div id="divMaster" name="divMaster" style={{backgroundColor:'WhiteSmoke',}}>
<Form id="miFormularioGuia">
{/* DIV para el titulo: Y SALIR*/}
<div id="divTituloYSalir" name="divTituloYSalir" style={{backgroundColor:'silver',paddingTop:'0', paddingBottom:"0%"}}>
  <Row style={{margin:'0',}}>
    <Col xs="11" style={{paddingTop:'1%',display:"flex"}}>
      <h3 id="tituloGastoH1" style={{marginRight:"2%"}}></h3>
      <h4 id="numeroFactura">Para Factura: {props.rowRegistroClon.Factura} de {props.rowRegistroClon.RazonSocial} </h4>
    </Col>
    <Col xs="1" style={{textAlign:'right',paddingTop:'0',paddingRight:'0',}}> 
      <Button style={{ width: '40px', height: '40px', marginRight:"8%"}} id="btnSalir" name="btnSalir" color="danger"    
        onClick= { async() => {         
          //Pregunto si realmente desea salir. Alomejor sa está saliendo por error
          const miResp = await mostrarSwalConfirmacionEliminarAnular('ALERTA',"Realmende desea salir ?")
          if (miResp.isDismissed) return //alomejor se arrepintio
          props.cerrarGuia('close')  
        }}>      
        <FontAwesomeIcon color="aquamarine" icon={faWindowClose} />
      </Button>              
    </Col>
  </Row>             
</div>

  <h4 id="tituloGastoH1">Destinatario</h4>
  { ParteDestinatario() }
  <h4 id="tituloGastoH1">Transportista</h4>
  { ParteTransportista() }
  <h4 id="tituloGastoH1">Viaje</h4>
  { ParteViaje() }
  { ParteGrid() }  
  { PartePie() }

</Form> {/* miFormularioGuia */}
{/************************** MODAL PARA CANTIDAD ****************/}
<Modal size={'md'} isOpen={ modalPedirCantidad }>  
  <PedirCantidad  
    miTitulo={rowRegistroClon?.DescripcionRealD + " / Cantidad Original=>" + rowRegistroClon?.CantD}
    miSubTitulo={'Indíque la cantidad'}   
    miValorTexto2D={rowRegistroClon?.CantGuia } //se lo envio como texto pero con dos decimales  
    miAceptaCero={true} //para saber si se acepta 0
    cerrarModal={async (miStatus,miCantGuiaNum) => { 
    //la variable miStatus es boolean, al estar en true quiere decir que si desea editar 
    //la variable miCantSolicitada ya viene como NUMBER y redondeada a 2 decimales
    set_modalPedirCantidad(false)
    if (miStatus==false) return

    //Reviso que la cantidad nueva sea menor igual a la original
    let cantOriginalEnFacturaNum=parseFloat(rowRegistroClon.CantD)
    if (miCantGuiaNum>cantOriginalEnFacturaNum){
      const miTituloSwal="La cantidad es muy grande: \n" + "Desea continuar ?"
      const miResp = await mostrarSwalConfirmacionEliminarAnular('ALERTA',miTituloSwal)
      if (miResp.isDismissed) return //alomejor se arrepintio
    }
    //Reviso que la cantidad NO sea cero
    if (miCantGuiaNum==0){
      const miTituloSwal="Seguro que desea colocar CERO ?"
      const miResp = await mostrarSwalConfirmacionEliminarAnular('ALERTA',miTituloSwal)
      if (miResp.isDismissed) return //alomejor se arrepintio
    }

    //Mando a actualizar el grid
    let nuevaCantidadEnGuiaTexto2D=miCantGuiaNum.toFixed(2)
    actualizarGridConDatosNuevos("CantGuia",nuevaCantidadEnGuiaTexto2D)
    }}/>
</Modal>  

{/*************************** MODAL PARA CAMBIAR LA DESCRIPCION ****************/}
<Modal style={{ background:'blue',}} size={'md'} isOpen={ modalPedirDescripcion } >
  <PedirTextoGenericoSerie
    miTitulo={"Indíque la Descipción"}
    miLongitudMaxima={300}
    textoViejo={ rowRegistroClon?.DescripcionRealD } //realmente es la descripcion
    cerrarModal={()=> set_modalPedirDescripcion(false) }
    regresarAlLlamador={async(textoNuevo) => { 
    //para la descripcion, NO se acepta vacio (le mando el nombre del campo y el nuevo valor)
    if (textoNuevo.length==0){
      mostrarSwalBotonAceptar("error","ATENCION","La descripción no puede estar vacía")
      return
    }
    actualizarGridConDatosNuevos("DescripcionRealD",textoNuevo)
    }
    }/>
</Modal>

{/*************************** MODAL PARA CAMBIAR LA SERIE ****************/}
<Modal style={{ background:'blue',}} size={'md'} isOpen={ modalSerial } >
  <PedirTextoGenericoSerie
    miTitulo={"Indíque la Serie"}
    miLongitudMaxima={100}
    textoViejo={ rowRegistroClon?.DescripcionAmpliadaD } //realmente es la serie
    cerrarModal={()=> set_modalSerial(false) }
    regresarAlLlamador={async(textoNuevo) => { 
      //para la serie, se acepta vacio (le mando el nombre del campo y el nuevo valor)
      actualizarGridConDatosNuevos("DescripcionAmpliadaD",textoNuevo)
    }
    }/>
</Modal>

{/************************** MODAL PARA CAMBIAR TEXTO COMPLEMENTARIO ****************/}
<Modal centered={true} size={'md'} isOpen={ modalTextoComplementario } >
  <PedirTextoComplementario
    miTitulo={"Texto Complementario"}
    miLongitudMaxima={300}
    textoViejo={ def_TextoComplementario }
    cerrarModal={()=> set_modalTextoComplementario(false) }
    regresarAlLlamador={(textoNuevo) => { 
      //se acepta vacio
      def_TextoComplementario=textoNuevo
    }
    }/>
</Modal>

{/************************** MODAL PARA CAMBIAR DE CLIENTE/DESTINATARIO ****************/}  
<Modal style={{ backgroundColor:'blue',}}  size={"xl"}  isOpen={ modalClientesBuscadorEnBDD } >
  <TabelaClientesBuscadorEnBDD
    cerrarModal={(accion,clienteClonado)=> {
      set_modalClientesBuscadorEnBDD(false)
      //accion puede ser: close/save/notfound
      if (accion=='close') return
      if (accion=='select') {
        def_IdRojoDestinatario=clienteClonado.IDr          
        def_CiRucDestinatario=clienteClonado.IdPrincipal
        def_NombreDestinatario=clienteClonado.RazonSocial
        set_txtCiRucDestinatario(def_CiRucDestinatario)
        set_txtDestinatarioNombre(def_NombreDestinatario)
      }    
  }}
    selectAIT={"A"} //deseo solo los clientes activos
  />
 </Modal>

</div> // divMaster
)}

const ComponentePrincipal=()=>{
  return (
    <AppContextConsumer>
      { (value) => {
        valueDC=value //copio el context a mi variable global
        return ComponentePrincipalBody()
      } }
    </AppContextConsumer>
  )
}

//*******************************************************************
// ***************** Programa principal *****************************
//*******************************************************************
if (nombreComponenteParaVerState=='guia') return ComponentePrincipal()

} //de IncGuiaRemision

export default IncGuiaRemision
